// @ts-nocheck
import { Slash } from "@insite/mobius/Breadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { linkUnderlineStyle } from "@store/Themes/common/mixins/link";
/* Store Custom Code - End */

const breadcrumbs: Styleguide["breadcrumbs"] = {
    defaultProps: {
        typographyProps: {
            color: "inherit",
            size: "inherit",
        },
        css: css`
            ${siteWidthStyles()}
            padding-top: ${pxToRem(16)};
            flex-wrap: wrap;
            /* Store Custom Code - Start */
            color: ${getColor("text.accent")};
            text-transform: uppercase;
            /* Store Custom Code - End */

            ${x =>
                breakpointValues(
                    [x.theme.design.typography.size.smaller, null, null, null, null /* Store Custom Code */],
                    "font-size",
                )}

            ${Slash} {
                margin: 0 ${pxToRem(8)};
            }

            a {
                ${linkStyles("inherit", "text.linkHover", false, false) /* Store Custom Code */}
                /* Store Custom Code - Start */
                ${linkUnderlineStyle("header.breadcrumbs", "text.linkHover")}
                font-weight: inherit;
                /* Store Custom Code - End */
            }

            /* Store Removed - [aria-current="page"] */
        `,
    },
};

export default breadcrumbs;
